'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getLocaleFromClientCookie } from '@/utils/getLocaleFromClientCookie';

type GoogleCaptchaWrapperProps = React.PropsWithChildren;

export const GoogleCaptchaWrapper = ({ children }: GoogleCaptchaWrapperProps) => {
  const locale = getLocaleFromClientCookie();

  return (
    <GoogleReCaptchaProvider
      language={locale}
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ''}
      scriptProps={{
        defer: true
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};
